import React, { Children, lazy, memo } from 'react';
import { motion } from 'framer-motion';
export function ProblemaSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="w-full bg-gray-50 py-6 px-4 md:py-16 overflow-hidden" data-id="element-132">
      <motion.div className="max-w-md md:max-w-2xl mx-auto text-center" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.2
    }} data-id="element-133">
        {/* Main Headline */}
        <motion.h2 variants={itemVariants} className="text-lg md:text-2xl font-extrabold text-blue-800 leading-snug mb-3" data-id="element-134">
          <span className="bg-pink-100 px-1" data-id="element-135">¡DESARROLLA</span>{' '}
          <span className="bg-cyan-100 px-1" data-id="element-136">EL CEREBRO DE TU BEBÉ</span>
          <br data-id="element-137" />
          <span className="bg-yellow-100 px-1" data-id="element-138">
            DESDE CASA CON AMOR Y JUEGOS!
          </span>
        </motion.h2>

        {/* Subtitle */}
        <motion.p variants={itemVariants} className="text-sm md:text-base text-gray-700 leading-relaxed mt-3 mb-5" data-id="element-139">
          Más de 260 actividades imprimibles para estimular su lenguaje,
          memoria, atención,
          <br className="hidden md:block" data-id="element-140" />
          creatividad, emociones y mucho más. Todo en un solo PDF fácil de usar.
        </motion.p>

        {/* GIFs - Side by side */}
        <motion.div variants={itemVariants} className="flex justify-between gap-2 mt-5" data-id="element-141">
          <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1770714240/IMG_2045-1_sc8mec.gif" alt="El libro que estimulará la inteligencia de tu bebé 💕" className="w-[48%] rounded-xl shadow-md object-cover" data-id="element-142" />
          <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1770714240/IMG_2049-1_kn99hd.gif" alt="Cientos de mamás ya lo usan" className="w-[48%] rounded-xl shadow-md object-cover" data-id="element-143" />
        </motion.div>

        {/* Impact Text */}
        <motion.div variants={itemVariants} className="mt-6" data-id="element-144">
          <h3 className="text-base md:text-xl font-bold text-blue-900 leading-snug" data-id="element-145">
            <span className="bg-blue-100 px-1" data-id="element-146">
              ¿Sabías que los primeros 3 años de vida definen
            </span>
            <br data-id="element-147" />
            <span className="bg-blue-100 px-1" data-id="element-148">
              el desarrollo futuro de tu hijo o hija?
            </span>
          </h3>

          <p className="mt-2 text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-149">
            Es la etapa más sensible, donde el cerebro se desarrolla a gran
            velocidad.
            <br data-id="element-150" />
            Pero muchos padres no saben <em data-id="element-151">cómo estimular a su bebé</em>{' '}
            correctamente…
            <br data-id="element-152" />Y terminan perdiendo una gran oportunidad.
          </p>

          <p className="mt-4 text-sm md:text-base text-gray-800 font-medium leading-relaxed" data-id="element-153">
            Tu bebé no solo necesita amor, también{' '}
            <span className="text-blue-700 font-semibold" data-id="element-154">
              juegos adecuados, estímulos diarios
            </span>
            <br data-id="element-155" />y actividades que potencien sus sentidos, lenguaje, atención y
            emociones.
          </p>
        </motion.div>
      </motion.div>
    </section>;
}